import { TablePaginationParams } from 'components/core-v2/molecules/table-pagination'

import { ApiAssetPriceWithHistory, ApiStrategyTemplate } from '../../../api/_legacy/generated-api'
import { MasterDetail, Section } from '../../../components/core-v2'
import { Errors } from '../../tradebuilder-v2/util'
import { EditAssetsActions } from '../state/edit-asset-slice'
import { AssetFull } from '../types'
import { AssetDetailsPanel } from './asset-details-panel'
import { AssetsPanel } from './assets-panel'

export type AssetsLayoutProps = {
  actions: EditAssetsActions
  assetPriceHistory?: ApiAssetPriceWithHistory
  assets: AssetFull[]
  availableAssetClasses: string[]
  availableCptyIds: string[]
  availableCurrencies: string[]
  availableStrategies: ApiStrategyTemplate[]
  canProceed: boolean
  canUserSave: boolean
  errors: Errors
  exDateNotification: string
  isLoading: boolean
  isNew: boolean
  numTotalAssets: number
  onAssetSearch?: (searchTerm: string) => void
  onChangeStrategyPermission: (strategyId: string, val: boolean) => void
  onFundManagerRenamed?: () => void
  onNotificationClose: () => void
  onPaginationChange: (updatedPagination: TablePaginationParams) => void
  onSaveAsset: () => void
  onSaveExDates: (selectedDates: Date[]) => void
  onSelectAsset: (id: string) => void
  onSelectNewAsset: () => void
  pagination: TablePaginationParams
  saveSuccess: boolean
  selectedAsset?: AssetFull
  serverErrors?: string[]
}

const AssetsLayout = ({
  actions,
  assetPriceHistory,
  assets,
  availableAssetClasses,
  availableCptyIds,
  availableCurrencies,
  availableStrategies,
  canProceed,
  canUserSave,
  errors,
  exDateNotification,
  isLoading,
  isNew,
  numTotalAssets,
  onAssetSearch,
  onChangeStrategyPermission,
  onFundManagerRenamed,
  onNotificationClose,
  onPaginationChange,
  onSaveAsset,
  onSaveExDates,
  onSelectAsset,
  onSelectNewAsset,
  pagination,
  saveSuccess,
  selectedAsset,
  serverErrors
}: AssetsLayoutProps) => (
  <MasterDetail
    detailChildren={
      <Section type="quaternary">
        <AssetDetailsPanel
          actions={actions}
          assetPriceHistory={assetPriceHistory}
          availableAssetClasses={availableAssetClasses}
          availableCptyIds={availableCptyIds}
          availableCurrencies={availableCurrencies}
          availableStrategies={availableStrategies}
          canProceed={canProceed}
          canUserSave={canUserSave}
          errors={errors}
          exDateNotification={exDateNotification}
          isNew={isNew}
          saveSuccess={saveSuccess}
          selectedAsset={selectedAsset}
          serverErrors={serverErrors}
          onChangeStrategyPermission={onChangeStrategyPermission}
          onNotificationClose={onNotificationClose}
          onSaveAsset={onSaveAsset}
          onSaveExDates={onSaveExDates}
        />
      </Section>
    }
    masterChildren={
      <Section type="primary">
        <AssetsPanel
          assets={assets}
          canUserSave={canUserSave}
          isLoading={isLoading}
          numTotalAssets={numTotalAssets}
          pagination={pagination}
          selectedAsset={selectedAsset}
          onFundManagerRenamed={onFundManagerRenamed}
          onPaginationChange={onPaginationChange}
          onSearch={onAssetSearch}
          onSelectAsset={onSelectAsset}
          onSelectNewAsset={onSelectNewAsset}
        />
      </Section>
    }
    width="normal"
  />
)

export default AssetsLayout
